import React, { Component } from "react";
import { getBrandsStorageRef } from "../helpers";

class Brands extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadURLs: [],
    };

    this.getImages();
  }

  getImages = () => {
    let { state } = this;
    const siteId = window.Config.siteId;
    getBrandsStorageRef(siteId)
      .listAll()
      .then((result) => {
        state.downloadURLs = [];
        this.setState(state);

        result.items.forEach((imageRef, index) => {
          imageRef
            .getDownloadURL()
            .then((url) => {
              state.downloadURLs.push(
                <div className="brand" key={index}>
                  <img src={url} className="card-img-top" alt="item.title" />
                </div>
              );
              this.setState(state);
            })
            .catch(function (error) {
              console.log(error);
            });
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  render() {
    return (
      <div className="container-lg brands">
        <div className="">{this.state.downloadURLs}</div>
      </div>
    );
  }
}

export default Brands;
